export default __webpack_public_path__ + "static/media/경남.577e9532.png";